// 英文翻译内容（与中文语言包结构一致）
export default {
    nav: {
        home: 'HOME',
        product: 'PRODUCT',
        contact: 'CONTACT',
        about: 'ABOUT'
    },
    // 其他模块的英文翻译（示例）
    common: {
        confirm: 'Confirm',
        cancel: 'Cancel',
        home: "HOME"
    },
    product: {
        title: 'Product List',
        price: 'Price',
        tirDescription: `Our {name} is designed with advanced TIR (Total Internal Reflection) optics for optimal light distribution. 
    With a length of {size}" inches, it is perfect for compact installation spaces while delivering powerful illumination. 
    This light bar meets SAE J845 standards, ensuring high quality and reliability for various applications.`,
        // Linear 光学型号描述（含占位符）
        linearDescription: `Our {name} features linear optics technology, providing uniform and far-reaching illumination. 
    At .
    {size}" inches, it balances compact design with powerful performance, making it ideal for a variety of vehicles and equipment.`
    },
    home: {
        category: {
            title: "SHOW BY CATEGORY",
            subtitle: "ALL CATEGORIES"
        },
        videoSection: {
            title: "Featured Videos"
        },
        video: {
            loading: "Loading video...",
            error: "Video loading failed",
            notSupported: "Your browser does not support video playback"
        },
        productVideos: {
            0: {
                title: "SY-001 TIR 47\" Full Size Led Light Bar",
                description: ""
            },
            1: {
                title: "SY-RT8 TIR Visor Light Bar",
                description: ""
            },
            2: {
                title: "HB-STT8",
                description: ""
            }
        },
        advantages: {
            advantage1: {
                title: "Assured quality you can trust",
                detail: "High-performance and reliable ISO certified products."
            },
            advantage2: {
                title: "ISO Certified Products",
                detail: "Tested and certified high-performance, top-quality signal lights."
            },
            advantage3: {
                title: "In Stock • Fast Delivery",
                detail: "Maintain strict quality standards while fulfilling orders with remarkable speed."
            },
            advantage4: {
                title: "Efficient yet steady",
                detail: "Efficient production processes, timely and guaranteed delivery."
            }
        },
        categories: {
            miniLightBars: "MINI LIGHT BARS",
            fullLightBars: "FULL LIGHT BARS",
            visorLightBars: "VISOR LIGHT BARS",
            deckDashLights: "DECK/DASH LIGHTS",
            grilleSurfaceMounts: "GRILLE/SURFACE MOUNTS",
            siren: "SIREN",
            trafficAdvisors: "TRAFFIC ADVISORS",
            mountingBrackets: "MOUNTING BRACKETS"
        },
        videos: {
            trafficAdvisors: "TRAFFIC ADVISORS",
            miniLightBars: "MINI LIGHT BARS",
            companyVideo: "Company Introduction"
        }
    },
    products: {
        product2: {
            title: "SY-001 TIR 36\" Full Size Led Light Bar",
            description: "High-performance full size LED light bar with TIR optics"
        },
        product9: {
            title: "SY-001 Linear 36\" Full Size Led Light Bar",
            description: "Linear design 36\" full size LED light bar"
        },
        product3: {
            title: "SY-001 TIR 47\" Full Size Led Light Bar",
            description: "47\" full size LED light bar with advanced TIR technology"
        },
        product10: {
            title: "SY-001 Linear 47\" Full Size Led Light Bar",
            description: "Linear optics 47\" full size LED light bar"
        }
    },
    textVideo: {
        title: 'Y-signal',
        description: '<p>Understand us better via the video.</p>',
        features: {
            quality: 'Excellent product quality',
            supplyChain: 'Complete efficient supply chain',
            design: 'Excellent design ability',
            experience: 'Rich production experience'
        },
        buttons: {
            learnMore: 'Learn More',
            contactUs: 'Contact Us'
        }
    },
    footer: {
        sections: {
            contactInfo: "Contact Information",
            products: "Products",
            company: "Company"
        },
        contactInfo: {
            workTime: "Monday -- Saturday",
            email: "Marketing@@y-signal.com",
            phone: "0577-85220619",
            address: "466 Jinhai Second Road, Wenzhou, Zhejiang",
            webUrl: "www.y-signal.com"
        },
        company: {
            aboutUs: "About Us",
            contactUs: "Contact Us",
            productCatalog: "Product Catalog"
        },
        copyright: "Copyright © Y-signal. All Rights Reserved"
    },
    // 产品分类（与其他组件共用）
    categories: {
        miniLightBars: "MINI LIGHT BARS",
        fullLightBars: "FULL LIGHT BARS",
        visorLightBars: "VISOR LIGHT BARS",
        deckDashLights: "DECK/DASH LIGHTS",
        grilleSurfaceMounts: "GRILLE/SURFACE MOUNTS",
        siren: "SIREN",
        trafficAdvisors: "TRAFFIC ADVISORS",
        mountingBrackets: "MOUNTING BRACKETS"
    },
    productList: {
        selectCategory: "Select Category"
    },
    productCategories: {
        allProducts: "All Products",
        allProductsDesc: "Browse all our products",
        miniLightBarsDesc: "Our mini light bars comes in sizes of 18-27 inches, making it easy to install and occupying a compact space.",
        fullLightBarsDesc: "Full-size light bars for maximum visibility",
        visorLightBarsDesc: "Mountable on vehicle visors for discreet use",
        deckDashLightsDesc: "Compact lights for dashboard or deck mounting",
        grilleSurfaceMountsDesc: "Grille and surface mountable lighting solutions",
        sirenDesc: "High-quality sirens for emergency vehicles",
        trafficAdvisorsDesc: "Traffic direction and safety lighting"
    },
    productSeries: {
        tirSeries: "TIR Series",
        linearSeries: "Linear Series",
        switchBoxes: "SWITCH BOXES",
        sy001Tir: "SY-001 TIR",
        sy001Linear: "SY-001 Linear",
        sy002Tir: "SY-002 TIR",
        mountingBrackets: "MOUNTING BRACKETS"
    },
    productNames: {
        miniLedLightBar: "{series} {size}\" Mini Led Light Bar",
        fullSizeLedLightBar: "{series} {size}\" Full Size Led Light Bar",
        g003LinearGrilleLight: "G003 Linear Grille Light",
        g004LinearGrilleLight: "G004 Linear Grille Light",
        g006LinearGrilleLight: "G006 Linear Grille Light",
        g003TirGrilleLight: "G003 TIR Grille Light",
        g004TirGrilleLight: "G004 TIR Grille Light",
        g006TirGrilleLight: "G006 TIR Grille Light",
        hbStt1: "HB-STT1",
        hbStt2: "HB-STT2",
        hbStt4: "HB-STT4",
        hbStt6: "HB-STT6",
        hbStt8: "HB-STT8",
        syRt8VisorLightBar: "SY-RT8 Visor Light Bar",
        syRt10VisorLightBar: "SY-RT10 Visor Light Bar",
        hSa100: "HS-A150",
        hSb200: "HS-B200",
        hSm100: "HS-M100",
        hPa100: "HP-A100",
        hSv100: "HS-V100",
        qAdhb: "HQ-122",
        qDstvb: "HQ-111",
        qHmb: "HQ-HMB",
        qSstb: "HQ-110",
        qSthb: "HQ-121",
        qLpb: "HQ-120",
        qRve: "HQ-RVE"
    },
    lookNow:"LOOK NOW",
    allFeatures:{
        "T18": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "60 total 3-watt LEDs" ,
            "34 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "11' of cable from light bar to connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
            "Max 3.4 Amp Draw",
        ],
        "L18": [
            "SAE J845 Standard" ,
            "Optic Technology - Linear Optics" ,
            "120 total 3-watt LEDs" ,
            "44 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "11' of cable from light bar to connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
            "Max 4.7 Amp Draw",
        ],
        "T27": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "84 total 3-watt LEDs" ,
            "34 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "L27": [
            "SAE J845 Standard" ,
            "Optic Technology - Linear Optics" ,
            "168 total 3-watt LEDs" ,
            "44 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "T36": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "108 total 3-watt LEDs" ,
            "34 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "L36": [
            "SAE J845 Standard" ,
            "Optic Technology - Linear Optics" ,
            "216 total 3-watt LEDs" ,
            "44 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "T47": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "132 total 3-watt LEDs" ,
            "34 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "L47": [
            "SAE J845 Standard" ,
            "Optic Technology - Linear Optics" ,
            "264 total 3-watt LEDs" ,
            "44 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "T55": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "156 total 3-watt LEDs" ,
            "34 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "L55": [
            "SAE J845 Standard" ,
            "Optic Technology - Linear Optics" ,
            "312 total 3-watt LEDs" ,
            "44 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "T63": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "180 total 3-watt LEDs" ,
            "34 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "L63": [
            "SAE J845 Standard" ,
            "Optic Technology - Linear Optics" ,
            "360 total 3-watt LEDs" ,
            "44 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "T71": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "204 total 3-watt LEDs" ,
            "34 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "L71": [
            "SAE J845 Standard" ,
            "Optic Technology - Linear Optics" ,
            "408 total 3-watt LEDs" ,
            "44 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "12' of cable from light bar to connector",
            "12.5' of power cable from connector",
            "12.5' of auxiliary cable from connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
        ],
        "GD1": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "40 total 3-watt LEDs" ,
            "30 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "11' of cable from light bar to connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
            "Max 3.4 Amp Draw",
        ],
        "GD2": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "40 total 3-watt LEDs" ,
            "30 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "11' of cable from light bar to connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
            "Max 3.4 Amp Draw",
        ],
        "GD4": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "40 total 3-watt LEDs" ,
            "30 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "11' of cable from light bar to connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
            "Max 3.4 Amp Draw",
        ],
        "GD6": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "40 total 3-watt LEDs" ,
            "30 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "11' of cable from light bar to connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
            "Max 3.4 Amp Draw",
        ],
        "GD8": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "40 total 3-watt LEDs" ,
            "30 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "11' of cable from light bar to connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
            "Max 3.4 Amp Draw",
        ],
        "ZT3": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "40 total 3-watt LEDs" ,
            "30 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "11' of cable from light bar to connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
            "Max 3.4 Amp Draw",
        ],
        "ZT4": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "40 total 3-watt LEDs" ,
            "30 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "11' of cable from light bar to connector", "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
            "Max 3.4 Amp Draw",
        ],
        "ZT6": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "40 total 3-watt LEDs" ,
            "30 total flash patterns" ,
            "Non-volatile memory recalls last flash pattern" ,
            "Lifespan of up to 100,000 hours" ,
            "Cig plug with On/Off switch & flash pattern toggle sold separately" ,
            "11' of cable from light bar to connector",
            "Weather-proof housing" ,
            "Includes Magnet brackets for mounting" ,
            "Powered by 11V-14V" ,
            "Max 3.4 Amp Draw",
        ],
        "ZL3": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "3 LED 3-watt LEDs" ,
            "Built in sync and alternate sync functionality" ,
            "24 available individual flash patterns" ,
            "3 alternate sync pattern speeds" ,
            "Non-volatile memory recalls last flash patterns" ,
            "Lifespan of up to 100,000 hours",
            "Includes 1 foot of cable" ,
            "Weather-proof housing" ,
            "Powered by 11V-14V" ,
            "Max 290 mAh Draw",
        ],
        "ZL4": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "4 LED 3-watt LEDs" ,
            "Built in sync and alternate sync functionality" ,
            "34 available individual flash patterns" ,
            "3 alternate sync pattern speeds" ,
            "Non-volatile memory recalls last flash patterns" ,
            "Lifespan of up to 100,000 hours",
            "Includes 1 foot of cable" ,
            "Weather-proof housing" ,
            "Powered by 11V-14V" ,
            "Max 570 mAh Draw",
        ],
        "ZL6": [
            "SAE J845 Standard" ,
            "Optic Technology - TIR Optics" ,
            "6 LED 3-watt LEDs" ,
            "Built in sync and alternate sync functionality" ,
            "34 available individual flash patterns" ,
            "3 alternate sync pattern speeds" ,
            "Non-volatile memory recalls last flash patterns" ,
            "Lifespan of up to 100,000 hours",
            "Includes 1 foot of cable" ,
            "Weather-proof housing" ,
            "Powered by 11V-14V" ,
            "Max 570 mAh Draw",
        ],

    },
    T18DES: "The SY-001 18 TIR LED Light Bar packed with 120 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
    T27DES: "The SY-001 27 TIR LED Light Bar packed with 168 pcs 3-Watt LEDs, this 27 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
    T36DES: "The SY-001 36 TIR LED Light Bar packed with 216 pcs 3-Watt LEDs, this 36 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
    T47DES: "The SY-001 47 TIR LED Light Bar packed with 264 pcs 3-Watt LEDs, this 47 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
    T55DES: "The SY-001 55 TIR LED Light Bar packed with 312 pcs 3-Watt LEDs, this 55 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
    T63DES: "The SY-001 63 TIR LED Light Bar packed with 360 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
    T71DES: "The SY-001 71 TIR LED Light Bar packed with 408 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
    L18DES: "The SY-001 18 Linear LED Light Bar packed with 120 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
    L27DES: "The SY-001 27 Linear LED Light Bar packed with 168 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
    L36DES: "The SY-001 36 Linear LED Light Bar packed with 216 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
    L47DES: "The SY-001 47 Linear LED Light Bar packed with 264 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
    L55DES: "The SY-001 55 Linear LED Light Bar packed with 312 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
    L63DES: "The SY-001 63 Linear LED Light Bar packed with 360 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
    L71DES: "The SY-001 71 Linear LED Light Bar packed with 408 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
    TGD: "Tough, anti-corrosive and water-resistant aluminum housing provides excellent heat dissipation\n" +
        "Available in dual or triple colors\n" +
        "Flexible in lengths, suitable for different vehicles for interior or exterior use\n" +
        "Easy installation with screw or bracket mount\n" +
        "Ready to be customized to meet your special requirements.",
    TZD: "Every unit comes in your choice of Red, Blue, Clear, Green, or Amber and with a variety of unique flash patterns. Features warning and working light functions Aluminum materials with spray coating• PC lens, UV resistant Two types of flexible brackets suitable for installation on car grilles, bumpers, and hoods IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance.\n",
    ZJ: "Mounting brackets provide the necessary support to securely install emergency signal lights to your vehicle. Choose from our generic and vehicle specific mounting brackets below to make installation of your products quick and easy.",
    ZYB: "One of the most sought-after signal light solutions is the interior LED visor light bar. With diverse configurations and versatile functions, these lights are ideal for multiple vehicle lighting needs. Whether you need undercover or low-profile illumination for your vehicle, our interior windshield visor lights deliver the perfect solution.\n" +
        "Featuring high-performance 3-watt LED technology encased in a compact, streamlined design, our budget-friendly range of LED visor light bars promises to surpass your expectations. Each unit combines powerful brightness with discreet aesthetics, making it an essential addition for safety, visibility, or specialized vehicle setups.",
    currentDes: "",
    JBQ: "In the realm of emergency response, sirens act as a non-negotiable asset for first responders and emergency vehicles. A loud, high-output siren is critical to asserting road dominance when time and safety are of the essence.",
    mini:"Mini Led Light Bar",
    full:"Full Size Led Light Bar",
    techSpecs: {
        length: "Size",
        opticTechnology: "Optic Technology",
        ledQuantity: "LED Quantity",
        flashPatterns: "Flash Patterns",
        powerSupply: "Power Supply",
        lifespan: "Lifespan",
        weatherResistance: "Weather Resistance",
        mounting: "Mounting",
        // 具体值的翻译
        powerValue: "11V-14V",
        lifespanValue: "Up to 100,000 hours",
        weatherValue: "Weather-proof housing",
        mountingValue: "Includes Magnet brackets",
        tirOptics: "TIR Optics",
        linearOptics: "Linear Optics"
    },
    flashPatterns: {
        tSeries: "34 total flash patterns",  // T系列闪烁模式
        lSeries: "44 total flash patterns" ,  // L系列闪烁模式
        zlSeries24: "24 total flash patterns" ,  // L系列闪烁模式
        zlSeries22: "22 total flash patterns" ,  // L系列闪烁模式
        zlSeries26: "26 total flash patterns" ,  // L系列闪烁模式
    },
    ledQuantity: {
        3: "3 total 3-watt LEDs",
        4: "4 total 3-watt LEDs",
        6: "6 total 3-watt LEDs",
        8: "8 total 3-watt LEDs",
        12: "12 total 3-watt LEDs",
        24: "24 total 3-watt LEDs",
        36: "36 total 3-watt LEDs",
        48: "48 total 3-watt LEDs",
        60: "60 total 3-watt LEDs",
        84: "84 total 3-watt LEDs",
        108: "108 total 3-watt LEDs",
        132: "132 total 3-watt LEDs",
        156: "156 total 3-watt LEDs",
        120: "120 total 3-watt LEDs",
        168: "168 total 3-watt LEDs",
        216: "216 total 3-watt LEDs",
        264: "264 total 3-watt LEDs",
        312: "312 total 3-watt LEDs",
        360: "360 total 3-watt LEDs",
        408: "408 total 3-watt LEDs",
        na: "N/A"
    },
    optic: {
        tir: "TIR Optics",    // T系列光学技术（英文保持原样）
        linear: "Linear Optics" // L系列光学技术（英文保持原样）
    },
    applicationScenarios: {
        emergency: "Emergency vehicles (ambulances, fire trucks)",
        lawEnforcement: "common vehicles",
        construction: "Construction equipment and machinery",
        offRoad: "Off-road vehicles and trucks",
        marine: "Marine vessels and boats",
        industrial: "Industrial and commercial vehicles"
    },
    noRelated: "No related accessories available for this product.",
    zapplicationScenarios: {
        // 新增场景翻译
        grilleMounting: "Vehicle grille mounting",
        emergencySignaling: "Emergency vehicle signaling",
        industrialIndication: "Industrial equipment indication"
    },
    gapplicationScenarios: {
        // 新增场景翻译
        grilleMounting:  "Deck/dash mounting",
        emergencySignaling:  "Emergency vehicle signaling",
        industrialIndication: "Marine vessel indication"
    },
    tapplicationScenarios: {
        // 新增场景翻译
        grilleMounting:  "Traffic advisor systems",
        emergencySignaling:  "Emergency vehicle signaling",
        industrialIndication: "Marine vessel indication"
    },
    grilleLight: "This grille light is designed for surface mounting, featuring compact size and powerful illumination.",
    strikerLight: "1\" striker light with TIR optics, ideal for compact signaling needs.",
    strikerLight2: "2\" striker light with TIR optics, ideal for compact signaling needs.",
    strikerLight4: "4\" striker light with TIR optics, ideal for compact signaling needs.",
    strikerLight6: "6\" striker light with TIR optics, ideal for compact signaling needs.",
    strikerLight8: "8\" striker light with TIR optics, ideal for compact signaling needs.",
    sirenSpecs: {
        // 规格名称
        controllerDimensions: "CONTROLLER DIMENSIONS",
        amplifierDimensions: "AMPLIFIER DIMENSIONS",
        powerOutput: "POWER OUTPUT",
        paHornFunctions: "PA&horn tone functions:",
        tonesInclude: "Tones include:",
        siren: "Siren:",
        horn: "Horn:",
        // 规格值
        controllerSize: "5.75\"Lx3.25\"Hx1.4\"D",
        amplifierSize: "8.5\"Lx2.75\"Hx5.75\"D",
        powerOutputValue: "200-Watt amplifier output(for 2 100-Watt speakers)",

        // 功能列表
        function1: "Programmable manual mode",
        function2: "Radio rebroadcast function",
        function3: "6 auxiliary switches rated for 10amps each",
        function4: "Functions as 200-Watt 'Dual Tone' siren with 2 speakers (or 100-Watt single tone siren with 1 speaker). 'Dual Tone' function enables independent siren tones to output from each speaker",
        function5: "Includes microphone",

        // 音调列表
        sirenTones: "Wail,Yelp,Sting,Mech,Tool,Hi-Lo",
        hornTones: "High,Low"
    },
    siren: {
        // 参数名称
        controllerDimensions: "CONTROLLER DIMENSIONS",
        amplifierDimensions: "AMPLIFIER DIMENSIONS",
        powerOutput: "POWER OUTPUT",
        paHornFunctions: "PA&horn tone functions:",
        tonesInclude: "Tones include:",
        siren: "Siren:",
        horn: "Horn:",

        // 参数值
        controllerSize: "5.75\"Lx3.25\"Hx1.4\"D",
        amplifierSize: "8.5\"Lx2.75\"Hx5.75\"D", // 修正原数据中的".5.75"为"5.75"
        powerOutputValue: "200-Watt amplifier output (for 2 100-Watt speakers)",

        // 功能列表
        func1: "Programmable manual mode",
        func2: "Radio rebroadcast function",
        func3: "6 auxiliary switches rated for 10amps each",
        func4: "Functions as 200-Watt 'Dual Tone' siren with 2 speakers (or 100-Watt single tone siren with 1 speaker). 'Dual Tone' function enables independent siren tones to output from each speaker",
        func5: "Includes microphone",

        // 音调列表
        sirenTones: "Wail,Yelp,Sting,Mech,Tool,Hi-Lo",
        hornTones: "High,Low"
    },
    smallSiren: {
        // 规格名称
        amplifierDimensions: "AMPLIFIER DIMENSIONS",
        powerOutput: "POWER OUTPUT",
        paWarningFunctions: "PA&warning tone functions:",
        tonesInclude: "Tones include:",
        siren: "Siren:",
        horn: "Horn:",

        // 规格值
        amplifierSize: "5.5\"Lx1.75\"Hx3.25\"D", // 修正原数据中的".3.25"为"3.25"
        powerOutputValue: "100-Watt amplifier output",
        combinedUnit: "Combined amplifier&controller unit",

        // 功能与音调
        func1: "Includes microphone",
        sirenTones: "Wail,Yelp,Sting,Mech,Tool,Hi-Lo",
        hornTones: "High,Low"
    },
    controllerSiren: {
        // 规格名称
        controllerDimensions: "CONTROLLER DIMENSIONS",
        amplifierDimensions: "AMPLIFIER DIMENSIONS",
        powerOutput: "POWER OUTPUT",
        paHornFunctions: "PA&horn tone functions:",
        tonesInclude: "Tones include:",
        siren: "Siren:",
        horn: "Horn:",

        // 规格值
        controllerSize: "2.5\"Lx4.9\"Hx0.8\"D", // 修正原数据中的".8"为"0.8"
        amplifierSize: "8.5\"Lx2.75\"Hx5.75\"D", // 修正原数据中的".5.75"为"5.75"
        powerOutputValue: "100-Watt amplifier output",

        // 功能列表
        func1: "Programmable manual mode",
        func2: "Radio rebroadcast function",
        func3: "6 auxiliary switches rated for 10amps each",
        func4: "Handheld controller with built in microphone",

        // 音调列表
        sirenTones: "Wail,Yelp,Sting,Mech,Tool,Hi-Lo",
        hornTones: "High,Low"
    },
    sirenSpecsV2: {
        // 规格名称
        controllerDimensions: "CONTROLLER DIMENSIONS",
        amplifierDimensions: "AMPLIFIER DIMENSIONS",
        powerOutput: "POWER OUTPUT",
        paHornFunctions: "PA&horn tone functions:",
        tonesInclude: "Tones include:",
        siren: "Siren:",
        horn: "Horn:",

        // 规格值（修正放大器尺寸笔误：.5.75→5.75）
        controllerSize: "5.75\"Lx3.25\"Hx1.4\"D",
        amplifierSize: "8.5\"Lx2.75\"Hx5.75\"D",
        powerOutputValue: "100-Watt amplifier output",

        // 功能列表
        func1: "Programmable manual mode",
        func2: "Radio rebroadcast function",
        func3: "6 auxiliary switches rated for 10amps each",
        func4: "Handheld controller with built in microphone",

        // 音调列表
        sirenTones: "Wail,Yelp,Sting,Mech,Tool,Hi-Lo",
        hornTones: "High,Low"
    },
    zjapplicationScenarios: {
        // 新增场景翻译
        grilleMounting:  "Vehicle grille mounting",
        emergencySignaling:  "Emergency vehicle signaling",
    },
    pageTitles: {
        productDetails: "Product Details",
        basicInformation: "Basic Information",
        technicalSpecifications: "Technical Specifications",
        parameterValue: "Parameter",
        value: " Value",
        applicationScenarios: "Application Scenarios",
        goInquire:"Go Inquire",
        relatedAccessories:"Related Accessories",
        patentNumber:"Patent Number",
        size:"Size"
    },
    contact: {
        title: "CONTACT INFORMATION",
        // 社交媒体平台名称
        facebook: "Facebook",
        instagram: "Instagram",
        productInquiryTitle: "Product Inquiry",   // 右侧询盘表单标题

        // 表单标签
        formLabels: {
            name: "Name:",
            email: "Email:",
            phone: "Phone:",
            product: "Product Interested In:",
            quantity: "Quantity:",
            message: "Message:"
        },

        // 按钮 & 提示
        submitBtnText: "Submit Inquiry",          // 提交按钮文本
        successMsg: "Thank you for your inquiry! We will contact you soon."

    },
    about: {
        // 页面核心文本
        title: "About Us Y-signal",
        biaoyu: "We firmly believe that focus makes us more professional.",
        sectionTitle: "Our Company", // 统计区顶部标题
        imgAlt: "Company Image", // 图片alt属性

        // 统计卡片描述
        stats: {
            professionalStaff: "Professional Staff",
            patents: "Patented Technologies",
            foundedYear: "Founded Year"
        },

        // 内容区块标题
        blocks: {
            companyOverview: "Company Overview",
            productAdvantages: "Product Advantages",
            serviceIdea: "Service Idea"
        },

        // 公司介绍详情（保持原文）
        des_a: "Wenzhou Shangyu Technology Co., Ltd. was established in 2018 and is a comprehensive technology enterprise that integrates research and development, production, and sales. It is one of the main manufacturers in China's signal light industry. At present, the company has more than 40 employees and owns over 90 patents and 1 copyright.\nWe focus on providing high brightness and high reliability signal lighting solutions for various industrial and emergency fields. Also we understand the importance of clear warning signals in ensuring personnel safety and guiding orderly actions in complex and ever-changing environments.",
        des_b: "The company has a wide range of product lines, including full light bars, Mini light bars, Visor light bars, Sirens, and speakers etc. Advanced optical design and material technology are used to ensure clear visibility even at long distances and in harsh weather conditions. With its excellent waterproof and dustproof performance, low energy consumption and long service life, it has won the trust of global customers.",
        des_c: "We focus on technological innovation and quality control, with a professional R&D team and strict production management system to ensure that every product meets the highest industry standards. Also we provide customized services to meet the special needs of different scenarios."
    }
};
